import { createSlice } from '@reduxjs/toolkit';

const isLoginModalOpenSlice = createSlice({
    name: 'isLoginModalOpen',
    initialState: {
        isLoginModalOpen: false
    },
    reducers: {
        setIsLoginModalOpen: (state, action) => {
            state.isLoginModalOpen = action.payload;
        }
    },
});


export const { setIsLoginModalOpen } = isLoginModalOpenSlice.actions;
export default isLoginModalOpenSlice.reducer;
